(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[195],{

/***/ 4359:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog",
      function () {
        return __webpack_require__(9193);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8403:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "y": function() { return /* reexport */ PostCard; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(6577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(9097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./utils/date-utils.ts
var date_utils = __webpack_require__(6915);
// EXTERNAL MODULE: ./utils/hooks/index.ts + 4 modules
var hooks = __webpack_require__(5574);
;// CONCATENATED MODULE: ./components/blog/PostCard.tsx





var PostCard = function(param) {
    var slug = param.slug, title = param.title, description = param.description, mainImage = param.mainImage, publishedAt = param.publishedAt, estimatedReadingTime = param.estimatedReadingTime;
    var imageProps = (0,hooks/* useSanityImage */.W6)(mainImage);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: "/blog/".concat(slug),
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            className: "group",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "relative aspect-[8/5]",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: imageProps.src,
                        loader: imageProps.loader,
                        alt: mainImage.alt,
                        placeholder: "blur",
                        blurDataURL: imageProps.blurDataURL,
                        className: "group-hover:saturate-[1.25] group-hover:scale-[1.01]",
                        layout: "fill",
                        objectFit: "cover"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "pt-4 pb-2 text-xl font-semibold text-navy-900 group-hover:text-indigo-600",
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "pb-4 text-sm text-gray-600",
                    children: description
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    className: "text-sm uppercase text-stone-700 font-accent",
                    children: [
                        publishedAt && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                (0,date_utils/* formatDate */.p)(new Date(publishedAt)),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "px-2",
                                    children: "•"
                                })
                            ]
                        }),
                        estimatedReadingTime,
                        " MIN READ"
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/blog/index.ts



/***/ }),

/***/ 3517:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ getQueryHelpers; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7328);
/* harmony import */ var clients_sanity__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3522);


/**
 * Get query helpers to query Sanity. This is necessary to make sure that the backend (for SSR)
 * and frontend (for Real-time preview), share the exact same querying code. This way, we are sure
 * the queries are built the exact same way.
 *
 * @param buildQuery A function used to build the query from the arguments passed, in case we
 * want to do any preprocessing using the args before returning the query. Usually, this should
 * not happen and the query should be using the args using parameters (e.g.) `$slug`).
 * @param initialArgs Arguments that should be supplied to the query but not needed to be passed
 * by `fetch` and `usePreviewSubscription`.
 */ var getQueryHelpers = function(buildQuery, initialArgs) {
    return {
        fetch: function(args, preview) {
            return (0,clients_sanity__WEBPACK_IMPORTED_MODULE_0__/* .getClient */ .s3)(preview).fetch(buildQuery(), (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, initialArgs, args));
        },
        usePreviewSubscription: function(initialData, args, preview) {
            return (0,clients_sanity__WEBPACK_IMPORTED_MODULE_0__/* .usePreviewSubscription */ .$r)(buildQuery(), {
                initialData: initialData,
                enabled: preview,
                params: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, initialArgs, args)
            });
        }
    };
};


/***/ }),

/***/ 7175:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ad": function() { return /* binding */ getPostQueryHelpers; },
  "Ev": function() { return /* binding */ getPostsWithSettingsQueryHelpers; }
});

// UNUSED EXPORTS: fetchPostsForIndexing, fetchPostsWithMinimalData

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(8788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(2228);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4776);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ../../node_modules/next-sanity/node_modules/groq/lib/groq.js
var groq = __webpack_require__(6711);
var groq_default = /*#__PURE__*/__webpack_require__.n(groq);
// EXTERNAL MODULE: ./clients/sanity.ts + 1 modules
var sanity = __webpack_require__(3522);
// EXTERNAL MODULE: ./data/helpers/get-query-helpers.ts
var get_query_helpers = __webpack_require__(3517);
;// CONCATENATED MODULE: ./data/helpers/image-projection.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "{\n  ...,\n  asset->{\n    _type,\n    _id,\n    url,\n    metadata {\n      lqip\n    }\n  }\n}\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var imageProjection = groq_default()(_templateObject());

;// CONCATENATED MODULE: ./data/posts.ts



function posts_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '*[_type == "post" && defined(slug.current)][].slug.current'
    ]);
    posts_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '*[_type == "post" && defined(slug.current)] { _id, "slug": slug.current, _updatedAt }'
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n      {\n        "categories": *[_type == "category"] {\n          _id,\n          title,\n          "posts": *[_type == "post" && references(^._id)][0...10] | order(publishedAt desc) {\n            _id,\n            title,\n            description,\n            mainImage ',
        ',\n            categories[]->{ _id, title },\n            publishedAt,\n            "slug": slug.current,\n            "estimatedReadingTime": round(length(pt::text(body)) / 5 / 180)\n          },\n        }[count(posts) > 0],\n        "all": {\n          "_id": "all",\n          "title": "All",\n          "posts": *[_type == "post"][0...10] | order(publishedAt desc) {\n            _id,\n            title,\n            description,\n            mainImage ',
        ',\n            categories[]->{ _id, title },\n            publishedAt,\n            "slug": slug.current,\n            "estimatedReadingTime": round(length(pt::text(body)) / 5 / 180)\n          },\n        },\n        "websiteSettings": *[_type == "websiteSettings"][0],\n      }\n    '
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n      *[_type == "post" && slug.current == $slug] | order(_updatedAt) [0] {\n        _id,\n        title,\n        description,\n        body,\n        mainImage ',
        ",\n        categories[]->{ _id, title },\n        publishedAt,\n        author->{\n          name,\n          jobTitle,\n          image ",
        ',\n          "slug": slug.current,\n        },\n        "slug": slug.current,\n        "estimatedReadingTime": round(length(pt::text(body)) / 5 / 180),\n        relatedPosts[]->{ \n          _id,\n          title,\n          description,\n          mainImage ',
        ',\n          categories[]->{ _id, title },\n          publishedAt,\n          "slug": slug.current,\n          "estimatedReadingTime": round(length(pt::text(body)) / 5 / 180)\n        },\n        "websiteSettings": *[_type == "websiteSettings"][0],\n      }\n    '
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




var fetchPostsWithMinimalData = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,sanity/* getClient */.s3)(false).fetch(groq_default()(posts_templateObject())));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetchPostsWithMinimalData() {
        return _ref.apply(this, arguments);
    };
}();
var fetchPostsForIndexing = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,sanity/* getClient */.s3)(false).fetch(groq_default()(_templateObject1())));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetchPostsForIndexing() {
        return _ref.apply(this, arguments);
    };
}();
var getPostsWithSettingsQueryHelpers = function() {
    return (0,get_query_helpers/* getQueryHelpers */.D)(function() {
        return groq_default()(_templateObject2(), imageProjection, imageProjection);
    });
};
var getPostQueryHelpers = function() {
    return (0,get_query_helpers/* getQueryHelpers */.D)(function() {
        return groq_default()(_templateObject3(), imageProjection, imageProjection, imageProjection);
    });
};


/***/ }),

/***/ 9193:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(7328);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2484);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9097);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6577);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(6277);
/* harmony import */ var data_posts__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7175);
/* harmony import */ var components_layouts__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(625);
/* harmony import */ var components_blog__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8403);
/* harmony import */ var components_ui__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2123);











var usePreviewSubscription = (0,data_posts__WEBPACK_IMPORTED_MODULE_4__/* .getPostsWithSettingsQueryHelpers */ .Ev)().usePreviewSubscription;
var Blog = function(param) {
    var data = param.data, preview = param.preview;
    var ref = usePreviewSubscription(data.page, {}, preview), page = ref.data;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("all"), active = ref1[0], setActive = ref1[1];
    var posts = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        var ref;
        return ((ref = [
            page.all
        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(page.categories)).find(function(param) {
            var _id = param._id;
            return _id === active;
        })) === null || ref === void 0 ? void 0 : ref.posts) || [];
    }, [
        page.all,
        page.categories,
        active
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_layouts__WEBPACK_IMPORTED_MODULE_5__/* .MainLayout */ .Z, {
        title: "Hypzz Blog",
        settings: page.websiteSettings,
        path: "/blog",
        preview: preview,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "bg-white",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "bg-[#FDFAFF]",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "container grid w-auto grid-cols-4 mx-4 auto-rows-auto md:mx-auto md:grid-cols-12 gap-x-6",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "col-span-full md:col-start-3 md:col-span-8",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("header", {
                                        className: "flex items-center justify-between py-8",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                href: "/",
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                        src: "/logo.svg",
                                                        height: 40,
                                                        width: 118.39,
                                                        title: "Hypzz",
                                                        alt: "logo"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                href: "/",
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    className: "bg-[#A26CFF] py-1 px-2 rounded text-gray-100 hover:bg-[#A46FFF]",
                                                    children: "Home"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                        className: "mt-8 text-5xl font-semibold text-navy-900",
                                        children: "blog."
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "mt-8 text-gray-500 uppercase font-accent",
                                        children: "Filter by category"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "flex mt-4 mb-8 space-x-4 overflow-hidden",
                                        children: [
                                            page.all
                                        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(page.categories)).map(function(param) {
                                            var _id = param._id, title = param.title;
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)("text-navy-900", _id === active ? "font-semibold" : ""),
                                                onClick: function() {
                                                    return setActive(_id);
                                                },
                                                children: title
                                            }, _id);
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "container grid w-auto grid-cols-4 py-24 mx-4 auto-rows-auto md:mx-auto md:grid-cols-12 gap-x-6",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                            className: "grid gap-12 lg:gap-16 col-span-full md:col-start-3 md:col-span-8 sm:grid-cols-2",
                            children: posts.map(function(p) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_blog__WEBPACK_IMPORTED_MODULE_6__/* .PostCard */ .y, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, p))
                                }, p._id);
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_ui__WEBPACK_IMPORTED_MODULE_7__/* .Newsletter */ .mA, {})
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (Blog);


/***/ }),

/***/ 6915:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ formatDate; }
/* harmony export */ });
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8966);

var formatDate = function(date) {
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(date, "PP");
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [525,747,106,769,625,774,888,179], function() { return __webpack_exec__(4359); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);